import { Flex } from "@chakra-ui/react";
import Switch from "react-switch";

import { colors } from "src/colors";
import { textStylesType } from "src/typography";

import { OFText } from "../OFText";

export type toggleSize = "large" | "small";

const TOGGLE_SIZES = {
  large: { width: 100, height: 40, handleDiameter: 30, margin: "10px" },
  small: { width: 68, height: 32, handleDiameter: 20, margin: "8px" }
};

const TEXT_STYLES = {
  large: { textStyle: "button1" },
  small: { textStyle: "button2" }
};

type Props = {
  size?: toggleSize;
  isChecked: boolean;
  onChange: (checked, event, id) => void;
  onText?: string;
  offText?: string;
  disabled?: boolean;
};

export const Toggle = ({
  isChecked,
  onChange,
  size = "large",
  onText = "ON",
  offText = "OFF",
  disabled = false
}: Props) => {
  const styles = TOGGLE_SIZES[size];

  return (
    <Switch
      onChange={onChange}
      checked={isChecked}
      onHandleColor={colors.orange[400]}
      offHandleColor={colors.grey[700]}
      offColor={colors.grey[300]}
      onColor={colors.grey[300]}
      disabled={disabled}
      uncheckedIcon={
        <Flex alignItems="center" h="100%" w="100%" justifyContent="flex-end">
          <OFText
            textStyle={TEXT_STYLES[size].textStyle as textStylesType}
            color={colors.black[900]}
            mr={styles.margin}
          >
            {offText}
          </OFText>
        </Flex>
      }
      checkedIcon={
        <Flex alignItems="center" h="100%" w="100%" justifyContent="flex-start">
          <OFText
            textStyle={TEXT_STYLES[size].textStyle as textStylesType}
            color={colors.black[900]}
            ml={styles.margin}
          >
            {onText}
          </OFText>
        </Flex>
      }
      activeBoxShadow="transparent"
      draggable={false}
      {...(size === "large" && {
        uncheckedHandleIcon: <Flex h="30px" w="40px" bg={colors.grey[700]} borderRadius="16px" />,
        checkedHandleIcon: (
          <Flex h="30px" w="40px" bg={colors.orange[400]} borderRadius="16px" ml="-10px" />
        )
      })}
      {...styles}
    />
  );
};
